import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
//import { thunk } from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { systemInfo } from "./Adapters/systemInfo/systemInfo.reducer";


const appReducer = combineReducers({
    systemInfo,
});
const rootReducer = (state, action) => {
    return appReducer(state, action);
}
const persistConfig = {
    key: 'root',
    blacklist: [],
    storage
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

//const store = createStore(persistedReducer, {});
//export default store;


export default () => {
    let store = configureStore({
        reducer: persistedReducer,
        devTools: false,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false}),
    });
    let persistor = persistStore(store);
    return { store, persistor }
}
